"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCostCenter = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconCostCenter = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.97.398L23.426 5.33a1 1 0 01.573.904V7H0v-.76a1 1 0 01.58-.908L11.279.392a2 2 0 011.691.006zM12 1.75a2 2 0 100 4 2 2 0 000-4zM1.258 21h21.484a1 1 0 01.992.876L24 24H0l.266-2.124A1 1 0 011.258 21zm.909-13h2.666L5.5 20h-4l.667-12zm8.5 0h2.666L14 20h-4l.667-12zm8.5 0h2.666l.667 12h-4l.667-12z",
  fillRule: "evenodd"
}));
exports.IconCostCenter = IconCostCenter;
//# sourceMappingURL=IconCostCenter.js.map